import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from './___LOGIC/___common/__language/translation.service';
import { AuthService } from './___LOGIC/__auth/auth.service';
import { RefreshService } from './___LOGIC/__common/refresh.service';
import { ConfigService } from './___LOGIC/___common/__config/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'voyjaleas-webapp';
  loading = false;
  private refreshSubject = new Subject<void>();

  constructor(private refreshService: RefreshService,private translate: TranslateService,private translationService: TranslationService,private authService: AuthService,private config: ConfigService) {
    // Set default language
    this.translate.setDefaultLang('es');
    //const browserLang = translate.getBrowserLang();
    //translate.use(browserLang.match(/en|es/) ? browserLang : 'en'); // Use browser language or default to English
    //browserLang.match(/en|es/) ? this.translationService.setLanguage(browserLang) : this.translationService.setLanguage('en');

    // FORCE
    this.translate.setDefaultLang('es');
    //
  }

  ngOnInit() {
    this.config.loadConfig();
    this.authService.checkSession().subscribe();

    this.refreshSubject.pipe(
      debounceTime(1000) // Ensures only one request per second
    ).subscribe(() => this.performRefresh());
  }


  ngOnDestroy(): void {
    this.refreshSubject.unsubscribe();
  }

  onPanMove(event: any) {
    if (event.deltaY > 100) { // Ensure it's a valid pull-down action
      this.refreshSubject.next(); // Triggers refresh, but debounced
    }
  }

  async onPanMoveOld(event: any) {
    if (event.deltaY > 100) { // Check if pulled down enough
      if (this.refreshService.shouldRefresh()) {
        this.loading = true;
        //console.log(`Refreshing data for ${this.currentRoute}...`);
        
        await this.refreshService.fetchData();

        this.loading = false;
        //console.log(`Data refreshed for ${this.currentRoute}`);
      } else {
        //console.log(`No need to refresh data for ${this.currentRoute}`);
      }
    }
  }

  async performRefresh() {
    if (this.refreshService.shouldRefresh()) {
      this.loading = true;
      /* console.log(`Refreshing data for ${this.currentRoute}...`); */

      await this.refreshService.fetchData();

      this.loading = false;
      /* console.log(`Data refreshed for ${this.currentRoute}`); */
    } else {
      /* console.log(`No need to refresh data for ${this.currentRoute}`); */
    }
  }


  isCurrentLang(lang){
    return this.translationService.getCurrentLanguage() == lang;
  }


  switchLanguage(language: string) {
    this.translate.use(language);
  }

}
